import { render, staticRenderFns } from "./ApplicationActivityOverview.vue?vue&type=template&id=54fd4472"
import script from "./ApplicationActivityOverview.vue?vue&type=script&lang=js"
export * from "./ApplicationActivityOverview.vue?vue&type=script&lang=js"
import style0 from "./ApplicationActivityOverview.vue?vue&type=style&index=0&id=54fd4472&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports